<header class="header" [class.scrolled]="isScrolled()">
  <div class="container header__inner">
    <a routerLink="/" class="header__logo">
      <img [src]="logoUrl()" alt="The Husk Bakery" style="height: 48px; object-fit: contain; mix-blend-mode: multiply;">
    </a>

    <button class="header__mobile-toggle" aria-label="Toggle Menu" (click)="toggleMenu()">
      <span class="bar" [class.active]="isMenuOpen()"></span>
      <span class="bar" [class.active]="isMenuOpen()"></span>
      <span class="bar" [class.active]="isMenuOpen()"></span>
    </button>

    <nav class="header__nav" [class.open]="isMenuOpen()">
      <ul class="header__menu">
        <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            (click)="closeMenu()">Home</a></li>

        <!-- Products Dropdown Menu -->
        <li class="has-dropdown" [class.open]="isMegamenuOpen()">
          <a class="dropdown-toggle" (click)="toggleMegamenu($event)">Products <i class="icon-chevron-down"></i></a>
          <ul class="dropdown-menu" (click)="closeMegamenu()">
            <li><a routerLink="/products/breads" (click)="closeMenu(); closeMegamenu()">Breads</a></li>
            <li><a routerLink="/products/pastries" (click)="closeMenu(); closeMegamenu()">Pastries</a></li>
            <li><a routerLink="/products/cakes" (click)="closeMenu(); closeMegamenu()">Cakes</a></li>
            <li><a routerLink="/products/drinks" (click)="closeMenu(); closeMegamenu()">Drinks</a></li>
          </ul>
        </li>

        <li><a routerLink="/recipes" routerLinkActive="active" (click)="closeMenu()">Recipes</a></li>
        <li><a routerLink="/our-story" routerLinkActive="active" (click)="closeMenu()">Our Story</a></li>
        <li><a routerLink="/location" routerLinkActive="active" (click)="closeMenu()">Location</a></li>
        <li><a routerLink="/blog" routerLinkActive="active" (click)="closeMenu()">Blog</a></li>
        <li><a routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">Contact</a></li>
        <li class="theme-toggle-wrapper">
          <button class="theme-toggle" (click)="themeService.toggleTheme()" aria-label="Toggle theme" [attr.data-current-theme]="themeService.theme()">
            <svg class="icon-sun" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>
            <svg class="icon-moon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>
          </button>
        </li>
      </ul>

    </nav>
  </div>
</header>